// @ts-check
// ====== Utility functions ======
/** @param {string} sel @param {ParentNode} [root] */
function $(sel, root = document) {
  return root.querySelector(sel);
}
function $$(sel, root = document) {
  return [...root.querySelectorAll(sel)];
}
function uid() {
  return 'i' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}

function escapeHtml(s) {
  return String(s == null ? '' : s).replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
  );
}

function statusClass(s) {
  if (!s) return '';
  const k = s.toLowerCase().trim();
  if (k === 'sì' || k === 'si') return 'status-si';
  if (k === 'no') return 'status-no';
  if (k === 'richieste') return 'status-richieste';
  if (k === 'da richiedere') return 'status-darichiedere';
  if (k === 'da eliminare') return 'status-daeliminare';
  if (k === 'eliminato') return 'status-eliminato';
  if (k === 'n/a' || k === 'na') return 'status-na';
  return '';
}

// Simbolo breve per ogni stato accesso: cue non basato sul colore (daltonici).
function statusSymbol(s) {
  const k = (s || '').toLowerCase().trim();
  if (k === 'sì' || k === 'si') return '✓';
  if (k === 'richieste') return '»';
  if (k === 'da richiedere') return '+';
  if (k === 'da eliminare') return '✕';
  if (k === 'no') return '–';
  if (k === 'eliminato') return '✕';
  if (k === 'n/a' || k === 'na') return '·';
  return '';
}

function perimetroClass(p) {
  const k = (p || '').toLowerCase().trim();
  if (k === 'azure') return 'per-azure';
  if (k === 'm365') return 'per-m365';
  if (k === 'power app') return 'per-powerapp';
  if (k === 'whistleblowing') return 'per-whistle';
  if (k === 'it') return 'per-it';
  return 'per-other';
}

function toast(msg) {
  const t = $('#toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.remove('hidden');
  clearTimeout(globalThis._toastT);
  globalThis._toastT = setTimeout(() => t.classList.add('hidden'), 2400);
}

function initials(name) {
  return (name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join('')
    .toUpperCase();
}

function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(+d)) return iso;
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function fmtDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(+d)) return iso;
  return d.toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(iso + (iso.length === 10 ? 'T23:59:59' : ''));
  if (isNaN(+d)) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.floor((+d - +today) / (1000 * 60 * 60 * 24));
}

function roleLabel(role) {
  if (role === 'admin') return 'Admin';
  if (role === 'utente' || role === 'risorsa') return 'Utente';
  return role || '—';
}

function fillSelect(sel, items, placeholder) {
  if (!sel) return;
  const current = sel.value;
  sel.innerHTML =
    `<option value="">${placeholder}</option>` +
    items.map((i) => `<option value="${escapeHtml(i)}">${escapeHtml(i)}</option>`).join('');
  if (items.includes(current)) sel.value = current;
}

function downloadFile(name, content, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Aggancio idempotente di un listener: lega l'handler all'elemento UNA sola
// volta, anche se la funzione di wiring viene rieseguita (es. dopo l'iniezione
// di una vista lazy). Usa un flag su dataset per ricordare cosa è già legato.
// Ritorna true se ha legato adesso, false se era già legato o l'elemento manca.
function bindOnce(el, type, handler) {
  if (!el) return false;
  const key = 'bound_' + type;
  if (el.dataset[key] === '1') return false;
  el.dataset[key] = '1';
  el.addEventListener(type, handler);
  return true;
}

Object.assign(globalThis, {
  $,
  $$,
  uid,
  escapeHtml,
  statusClass,
  statusSymbol,
  perimetroClass,
  toast,
  initials,
  fmtDate,
  fmtDateTime,
  daysUntil,
  roleLabel,
  fillSelect,
  downloadFile,
  bindOnce
});

// Export nominali: oltre alla registrazione su globalThis (usata dai moduli UI
// con bare-identifier), così le funzioni pure sono importabili e testabili
// direttamente (vedi tests/unit/utils.test.js). Passo verso veri moduli ES.
export {
  $,
  $$,
  uid,
  escapeHtml,
  statusClass,
  statusSymbol,
  perimetroClass,
  toast,
  initials,
  fmtDate,
  fmtDateTime,
  daysUntil,
  roleLabel,
  fillSelect,
  downloadFile,
  bindOnce
};
